import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './congrats_page.css';

const Congrats_page = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [particles, setParticles] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    // Trigger animations on mount
    setIsVisible(true);
    
    // Create floating particles
    const createParticles = () => {
      const newParticles = [];
      for (let i = 0; i < 100; i++) {
        newParticles.push({
          id: i,
          x: Math.random() * window.innerWidth,
          y: Math.random() * window.innerHeight,
          size: Math.random() * 6 + 1,
          speed: Math.random() * 3 + 0.3,
          opacity: Math.random() * 0.8 + 0.1,
          delay: Math.random() * 3,
          direction: Math.random() * 360,
          type: Math.random() > 0.7 ? 'large' : 'small'
        });
      }
      setParticles(newParticles);
    };

    createParticles();

    // Animate particles
    const animateParticles = () => {
      setParticles(prev => prev.map(particle => {
        let x = particle.x + Math.cos(particle.direction * Math.PI / 180) * particle.speed;
        let y = particle.y + Math.sin(particle.direction * Math.PI / 180) * particle.speed;
        x = x > window.innerWidth ? 0 : x < 0 ? window.innerWidth : x;
        y = y > window.innerHeight ? 0 : y < 0 ? window.innerHeight : y;
        return { ...particle, x, y };
      }));
    };

    const interval = setInterval(animateParticles, 50);
    return () => clearInterval(interval);
  }, []);

  // Handle back to home navigation
  const handleBackToHome = () => {
    navigate('/');
  };

  return (
    <div className="congrats-container">
      {/* Animated Background */}
      <div className="congrats-background">
        <div className="congrats-gradient-overlay"></div>
        
        {/* Floating Particles */}
        {particles.map(particle => (
          <div
            key={particle.id}
            className={`congrats-particle ${particle.type}`}
            style={{
              left: particle.x,
              top: particle.y,
              width: particle.size,
              height: particle.size,
              opacity: particle.opacity,
              animationDelay: `${particle.delay}s`
            }}
          />
        ))}
        
        {/* Geometric Shapes */}
        <div className="congrats-shape shape-1"></div>
        <div className="congrats-shape shape-2"></div>
        <div className="congrats-shape shape-3"></div>
        <div className="congrats-shape shape-4"></div>
      </div>

      {/* Main Content */}
      <div className="congrats-content">
        <div className={`congrats-card ${isVisible ? 'visible' : ''}`}>
          {/* Success Icon */}
          <div className="congrats-icon-container">
            <div className="congrats-icon">
              <img 
                src="/logo.png" 
                alt="Trillions Logo" 
                className="congrats-logo"
              />
            </div>
            <div className="congrats-icon-ring"></div>
            <div className="congrats-icon-ring-2"></div>
          </div>

          {/* Main Message */}
          <div className="congrats-message">
            <h1 className="congrats-title">
              <span className="congrats-title-main">Congratulations!</span>
              <span className="congrats-title-sub">Transaction Successful</span>
            </h1>
            <p className="congrats-description">
              Your transaction has been processed successfully. Thank you for choosing Trillions!
            </p>
          </div>


          {/* Action Buttons */}
          <div className="congrats-actions">
            <button className="congrats-btn secondary" onClick={handleBackToHome}>
              Back to Home
            </button>
          </div>

          {/* Additional Info */}
          <div className="congrats-footer">
            <p className="congrats-footer-text">
              For any queries or assistance, please contact your assigned agent.
            </p>
            <div className="congrats-footer-links">
              <a href="/terms" className="congrats-link">Terms & Conditions</a>
              <span className="congrats-separator">•</span>
              <a href="/policy" className="congrats-link">Privacy Policy</a>
              <span className="congrats-separator">•</span>
              <a href="/contact" className="congrats-link">Support</a>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
};

export default Congrats_page;
